<template>
  <div class="row logged-user-header navbar navbar-expand-lg navbar-light bg-light">
    <div class="col">
      <router-link to="/">Accueil</router-link>
      <router-link to="/lobby" v-if="username">Salon</router-link>
      <router-link to="/rating">Scores</router-link>
      <router-link to="/rules" class="d-none d-md-inline">Règles</router-link>
      <router-link to="/contact" v-if="username">Contact</router-link>
      <b-dropdown text="Admin" size="sm" variant="link" right offset="-15" v-if="role === 'admin'">
        <b-dropdown-item to="/admin/users">Joueurs</b-dropdown-item>
        <b-dropdown-item to="/admin/cognitousers">Utilisateurs à confirmer</b-dropdown-item>
        <b-dropdown-item to="/admin/payments">Paiements</b-dropdown-item>
        <b-dropdown-item to="/admin/statistics">Statistiques</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="col-3 text-right" v-if="username">
      <b-dropdown :text="username" size="sm" variant="link" right offset="-15">
        <li class="text-center">
          <img v-bind:src="picture" v-if="picture" width="96"/>
          <img src="../assets/default-profile.png" v-else width="96"/>
        </li>
        <b-dropdown-item to="/profile">Mon compte</b-dropdown-item>
        <b-dropdown-item to="/support" v-if="role === 'user'">Adhérer à LCT</b-dropdown-item>
        <b-dropdown-item to="/support" v-if="role === 'premium' || role === 'admin'">
          Soutenir LCT</b-dropdown-item>
        <b-dropdown-item @click="logout">Déconnexion</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import iam from '../iam';

export default {
  name: 'Logged-User',
  data() {
    return {
      picture: iam.getConnectedUser() ? iam.getConnectedUser().picture : undefined,
      role: iam.getConnectedUser() ? sessionStorage.getItem('userrole') : undefined,
      username: iam.getConnectedUser() ? iam.getConnectedUser().username : undefined,
    };
  },
  methods: {
    logout() {
      iam.logout();
      this.$router.push({ path: '/?logout' });
    },
  },
};
</script>

<style>
.logged-user-header .dropdown-toggle::after {
    vertical-align: 0.155em;
}
.navbar a{
  font-size: 0.8rem;
  color: black;
  margin-right: 16px;
}
.navbar li a{
  margin-right: 0;
  font-size: 1rem;
}
.navbar .dropdown-item:hover, .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: white;
}
.navbar{
  padding: 0;
}
.navbar .b-dropdown ul {
  background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/LoggedUser.vue